import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin, WizCard, WizForm, WizRow, WizCol, WizButton } = component_tool
const { WizContainer } = framework_tool

import './index.less'

class PersonalityChecklist extends WizContainer {

    componentName = 'PersonalityChecklist'

    constructor(props) {
        super(props)
        this.state = {
        }
    }

    _componentDidMount() {
        this._list()
    }

    _list = () => {
        this.doAction({
            path: 'personalityChecklist/list',
            payload: {
                key: 'personalityChecklist',
                apiParams: {}
            }
        })
    }

    _renderItem = (item, index) => {
        let { id, text, value } = item
        return (
            <div key={'item_' + id + '_' + index} className='item' >
                <div className='title'>{value}</div>
                <div className='content' dangerouslySetInnerHTML={{ __html: text }}></div>
            </div>
        )
    }

    _render() {
        let { personalityChecklistLoading } = this.props
        let { code, data } = this.props.list
        let list = code === 1 ? data : []
        return (
            <WizSpin spinning={personalityChecklistLoading} >
                <WizCard title='性格测试对照表'>
                    <div className='personality-checklist'>
                        {list.map((item, index) => this._renderItem(item, index))}
                    </div>
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { personalityChecklist } = state
    const list = modelUtils.getModelEntity(personalityChecklist, 'personalityChecklist')
    const loading = modelUtils.getLoadingState(state, 'personalityChecklist')
    return {
        list,
        ...loading
    }
}

export default connect(mapStateToProps)(PersonalityChecklist)
